(ns ductile.ui.nexus
  (:require [ductile.ui.components :as ui]
            [ductile.ui.deframe :as deframe]))

(defn view [_result _match]
  [:div.flex.flex-col.gap-4
   [:div.flex.item.center.gap-2
    [:div.font-bold "Counter is: " @(deframe/!route-get ::counter 0)]
    [ui/button
     {:variant :primary
      :on {:click [[:store/route-update ::counter inc]]}}
     "Count up!"]]
   [:div
    [:div.flex.gap-2.items-center
     [:label "Your name: "]
     [ui/input
      {:type "text"
       :width :md
       :on {:input [[:store/route-assoc ::name [:event.target/value]]]}}]]
    [:div "👋 Hello " @(deframe/!route-get ::name "Stranger") "!"]]])
